import React from 'react';
import InfoCard from '../../ForCreator/InfoCard/InfoCard';
import gearIcon from '../../../assets/svg/icon/edc-info-setting-white.svg';
import trendingUpIcon from '../../../assets/svg/icon/edc-info-trending-up-white.svg';
import authenticityIcon from '../../../assets/svg/icon/edc-info-trust-white.svg';
import divercityIcon from '../../../assets/svg/icon/edc-info-divercity-white.svg';
import './VerticalInfoContainer.css';

const VerticalInfoContainer = () => {
  const backgroundColor = 'transparent';
  const headingColor = '#00B1B5';
  const headingSize = '';
  const cardWidth = '400px';

  return (
    <div className="vertical-info-container-wrapper-for-brand">
      <div className="vertical-info-container-heading-wrapper-for-brand">
        <h2 className="vertical-info-container-heading-for-brand">
          ADVERTISING RE-DEFINED
        </h2>
      </div>
      <div className="vertical-info-container-for-brand">
        <InfoCard
          image={authenticityIcon}
          heading="AUTHENTIC & HYPER-RELEVANT CONTENT AT SCALE"
          text="Content needs to do more than just fill a placement - It needs to win attention.
            Winning attention requires creatives which resonate with different audiences in different moments.
            The key to performance?  Relevance, personalization, and scale of content."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={trendingUpIcon}
          heading="EVERYDAY CONTENT WHICH BECOMES YOUR TARGETING"
          text="Created by your community for you community.
                Real people creating relatable, scroll-native content which reflects how consumers engage today.
                We deliver diverse, insight-driven creative which acts as the targeting layer itself.
                Our channel agnostic approach is built to scale across platforms and audiences."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={divercityIcon}
          heading="DEMOCRATIZED OPPORTUNITIES FOR CREATORS"
          text="The world is full of untapped creativity.
          Our platform removes barriers for Everyday Creators, providing opportunities at scale, whilst giving brands access to untapped creativity.
          Our innovative process removes all of the heavy lifting for brands, providing authentic, real content at scale within just a few clicks."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
        <InfoCard
          image={gearIcon}
          heading="YOUR CONTENT INFRASTRUCTURE
          FOR THE ALGORITHMIC ERA"
          text="Fuelled by media, our solution is more than just content.
          We nurture a collective of Everyday Creators specific to your brand.
          Our model turns content from a subjective cost into an objective investment. 
          Creator incentives are tied to performance, aligning brand success with creator success."
          backgroundColor={backgroundColor}
          headingColor={headingColor}
          headingSize={headingSize}
          infoCardWidth={cardWidth}
        />
      </div>
    </div>
  );
};

export default VerticalInfoContainer;
